import { Box, styled } from "@mui/material";

type StyledInvoiceListItemProps = {
  type: string;
  fullScreen: boolean;
  hasBeenPayed: boolean;
};

export const StyledInvoiceListItem = styled(Box)<StyledInvoiceListItemProps>(
  ({ theme, type, hasBeenPayed, fullScreen }) => ({
    borderLeft: `5px solid ${
      hasBeenPayed ? theme.palette.success.main : theme.palette.error.main
    }`,
    gap: ".5rem",
    paddingInline: ".5rem",
    height: "fit-content",
    minHeight: "2rem",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    h5: {
      color: theme.contrast.dark,
      fontWeight: "bold",
      textAlign: "center",
    },
    ".date": {
      width: fullScreen ? "7.5%" : "30%",
    },
     ".ref": {
      width: "12.5%",
    },
    ".name": {
      width: fullScreen ? "15%" : "45%",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textAlign: "start",
    },
    ".description": {
      textAlign: "start",
      width: "15%",
    },
    ".yearQuarter": {
      width: "7.5%",
    },
    ".type": {
      color: theme.color.background,
      alignItems: "center",
      fontWeight: "bold",
      height: "1.8rem",
      width: "7.5%",
      textTransform: "capitalize",
      background:
        type === "inkomst"
          ? theme.palette.success.main
          : type === "uitgave"
          ? theme.palette.error.main
          : type === "uitbetaling" ? theme.palette.warning.main : theme.palette.info.main,
    },
    ".value": {
      width: fullScreen ? "7.5%" : "30%",
    },
    ".buttonWrapper": {
      display: "flex",
      width: "5%",
      justifyContent: "space-evenly",
      ".button": {
        cursor: "pointer"
      }
    },
    [`@media screen and (max-width: ${theme.breakpoints.values.wide}px)`]: {
      ".date": {},
      ".ref": {
        width: "15%",
      },
      ".name": {},
      ".description": {
        width: "12.5%",
      },
      ".yearQuarter": {},
      ".type": {},
      ".value": {},
      ".buttonWrapper": {},
    }
  })
);
